import React, {useEffect, useState} from 'react';
import Dialog from "components/Dialog";
import Tr from "translations/Translations";
import DoubleButton from "components/popup/components/DoubleButton";
import {makeStyles} from "@material-ui/core";
import Form from "components/Form";
import useId from "hooks/useId";
import Loading from "components/Loading";
import DealingsService from "services/DealingsService";
import PartsTable from "components/PartsTable";
import {connect} from "react-redux";
import {filterByCurrentLoadedDealings, findTemporaryDealingIds} from "../lib/manipulateElementsOnParts";
import stageValues from "../constants/stage.values";
import {CONDITION_TYPE_OTHER, CONDITIONS_LABEL, CONDITIONS_LABEL_PZP_2021} from "components/popup/newCondition/constants/condition.values";
import {CRYTERIUM_TYPE, CRYTERIUM_TYPE_LABEL} from "components/popup/newCriteria/constants/criterium.type";
import {getDemandPZPType} from "libs/getDemandStatus";
import PZPType from "constants/PZPType";
import VS from "constants/ValidationShema";

const useStyle = makeStyles(theme => ({
    root: {
        minHeight: 75
    }
}));


const getCritDisplayName = (crit, stageName) => {

    const demandPzpType = getDemandPZPType();
    const conditionLabels = PZPType.PZP_2021 === demandPzpType ? CONDITIONS_LABEL_PZP_2021 : CONDITIONS_LABEL;

    let name;
    switch (stageName) {
        case stageValues.CONDITIONS:
            name = crit.type === CONDITION_TYPE_OTHER ? crit.otherName : conditionLabels[crit.type];
            break;
        case stageValues.CRITERIONS:
            name = crit.type === CRYTERIUM_TYPE.OTHER ? crit.otherName : CRYTERIUM_TYPE_LABEL[crit.type];
            break;
        case stageValues.PARAMETERS:
        case stageValues.ITEM_PARAMETERS:
            name = crit.name;
            break;
        default:
            name = "";
            break;
    }
    return name;

}

const ConfirmDeleteCriterion = (
    {
        onClose = () => {
        },
        onDelete = () => {
        },
        partId,
        demandId,
        stageId,
        initCrit, //usuwane kryterium
        allItems,
        id,
        formSubmit,
    }) => {

    const [elementList, setElementList] = useState(null);
    const [critName, setCritName] = useState("");
    const classes = useStyle();

    const formId = useId();

    const handleClose = () => {
        setElementList(null);
        onClose();
    };

    const handleSubmit = (values) => {
        onDelete(values);
    };

    const handleConfirm = () => {
        formSubmit[formId]();
    };

    useEffect(() => {
        if (initCrit) {

            const splitId = id.split('.');
            splitId.shift();// remove index
            const stageName = splitId[splitId.length - 1];
            const critDisplayName = getCritDisplayName(initCrit, stageName);
            setCritName(critDisplayName);
            if (initCrit.identity < 0) {
                DealingsService.getDealingsMatchingCriterionName(demandId, stageId, stageName, critDisplayName).then((dealingsContains) => {
                    const ids = findTemporaryDealingIds(dealingsContains, allItems, id, initCrit);
                    const filtered = allItems.filter(x => ids.indexOf(x.identity) > -1);
                    setElementList(filtered);

                });

            } else {
                DealingsService.getDealingsMatchingCriterion(demandId, initCrit.identity).then((dealingsContains) => {

                    filterByCurrentLoadedDealings(dealingsContains, allItems, id, initCrit);
                    const ids = dealingsContains.map(x => x.identity);
                    const filtered = allItems.filter(x => ids.indexOf(x.identity) > -1);
                    setElementList(filtered);
                });
            }
        }
    }, [demandId, initCrit, allItems, id, stageId]);

    return (
        <Dialog
            contentClassName={classes.root}
            title={Tr('confirm_delete')}
            open={true}
            maxWidth='md'
            onClose={handleClose}
        >
            {elementList == null && <Loading/>}

            {elementList !== null &&
            <>
                <Form
                    id={formId}
                    onSubmit={handleSubmit}
                    initialValues={{
                        parts: {
                            [partId]: true,
                        },
                    }}
                    validationSchema={VS.any()}
                >
                    {(formikProps) => (
                        <>

                            {elementList.length >= 1 &&
                            <>
                                <PartsTable
                                    id={'parts'}
                                    formikProps={formikProps}
                                    elementList={elementList}
                                    label={Tr('select_dealings_to_crit_delete', {critName})}
                                />
                            </>
                            }
                        </>
                    )}
                </Form>
                <DoubleButton
                    justify='flex-end'
                    labelFirst={Tr('cancel')}
                    labelSecond={Tr('delete')}
                    onClickFirst={handleClose}
                    onClickSecond={handleConfirm}
                />
            </>}
        </Dialog>
    );
};


export default connect((state) => ({
    formSubmit: state.form
}), {})(ConfirmDeleteCriterion);